import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=6d099001&scoped=true&"
import script from "./WorkPlace.vue?vue&type=script&lang=tsx&"
export * from "./WorkPlace.vue?vue&type=script&lang=tsx&"
import style0 from "./WorkPlace.vue?vue&type=style&index=0&id=6d099001&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d099001",
  null
  
)

export default component.exports